import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { AlertCircle } from 'lucide-react'

export const Route = createFileRoute('/(app)/error')({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter();
  return (
    <div className="flex items-center justify-center h-full w-full">
      <Card className="my-10 w-96">
        <CardContent>

          <div className="flex flex-col gap-5 justify-center items-center ">

            <div className="flex flex-col justify-center">
              <div className="flex items-center bg-black p-2 rounded-md">
                <img
                  className="w-auto h-5"
                  src="EssilorLuxotticaWhite.svg" // Replace with your logo path
                  alt="App Logo"
                  width={120} // Adjust size as needed
                  height={60} // Adjust size as needed
                />
              </div>
              <div className="text-normal font-Avenir text-black flex items-center">
                <span className="inline-flex mr-3">
                  <span className="h-3 w-3 bg-black rounded-full"></span>
                  <span className="h-3 w-3 bg-black rounded-full ml-1"></span>
                </span>
                MONTHLY CLOSING
              </div>

            </div>
            <Alert variant="destructive">
              <AlertCircle></AlertCircle>
              <AlertTitle>
                Error loading application
              </AlertTitle>
              <AlertDescription>
                An error occurred while loading the app. Please try again later.
              </AlertDescription>

            </Alert>
            <Button variant="outline" className="ml-4" onClick={() => router.navigate({to: "/tasks"})}>
              Retry
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
